/** Normalize API/editor values for templates.includeInSoap (boolean or legacy string). */
export function parseIncludeInSoapFlag(raw: unknown): boolean {
  return raw === true || raw === "true";
}

export function isDocumentTemplateType(
  templateType: unknown,
): boolean {
  return String(templateType ?? "").trim() === "Document";
}

/**
 * Document templates only contribute to SOAP / plan-summary context when includeInSoap is Yes.
 * Non-document templates are not gated by this flag.
 */
export function isDocumentTemplateIncludedInSoapNote(
  template:
    | { templateType?: unknown; includeInSoap?: unknown }
    | null
    | undefined,
): boolean {
  if (!template || !isDocumentTemplateType(template.templateType)) {
    return true;
  }
  return parseIncludeInSoapFlag(template.includeInSoap);
}

export function shouldExcludeDocumentTemplateFromSoapContext(
  template:
    | { templateType?: unknown; includeInSoap?: unknown }
    | null
    | undefined,
): boolean {
  if (!template || !isDocumentTemplateType(template.templateType)) {
    return false;
  }
  return !isDocumentTemplateIncludedInSoapNote(template);
}
